<campus-slideout-modal-stack [activePanel]="isOpen ? 0 : -1">
  <campus-slideout-modal (scrimClicked)="close()" (animationDone)="closeDone()">
    <campus-slideout-modal-header-content>
      <p class="[ title-large ]">Beeldwoordenboek</p>
    </campus-slideout-modal-header-content>
    <campus-slideout-modal-header-actions>
      <dcr-inline-icon-button icon="shared:close" (click)="close()"></dcr-inline-icon-button>
    </campus-slideout-modal-header-actions>
    <div class="[ stack stack-space-m ]">
      <campus-search-term
        placeholder=""
        [autoComplete]="false"
        (valueChange)="searchTermUpdated($event)"
        [emitOnTextChange]="true"
        [showReset]="true"
        [showMagnifier]="true"
      ></campus-search-term>

      @for (word of filteredWords$ | async; track word) {
        <dcr-card
          orientation="horizontal"
          hero-type="video"
          style="--dcr-comp-card-max-width: 800px"
          [id]="getCardId(word.id)"
          >
          <dcr-image
            slot="hero"
            class="[ corner-s ]"
            [src]="word.image | assetsPath: 'images':'image-dict'"
            [alt]="word.label"
            autofill
          ></dcr-image>
          <div slot="header" class="[ stack stack-space-2xs ][ on-surface-variant ][ p-s ]">
            <!--todo: put `word.label` in headline once we have a reader that can access shadowDOM and remove `p-s` class above-->
            <p class="[ title-large on-surface ]">{{ word.label }}</p>
            <campus-froala-viewer [content]="word.meaning"></campus-froala-viewer>
            <dcr-divider></dcr-divider>
            <campus-froala-viewer [content]="word.example"></campus-froala-viewer>
          </div>
          @if (isReadSpeakerEnabled) {
            <div slot="header-action">
              <dcr-inline-icon-button
                icon="image-dict:speaker"
                data-aria-label="Lees luidop"
                (click)="readText(word.id)"
              ></dcr-inline-icon-button>
            </div>
          }
        </dcr-card>
      }
    </div>
  </campus-slideout-modal>
</campus-slideout-modal-stack>
